module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Bold-55458516f6d8ac9de6eb2638300d54ee.woff";